import { isCheckPermission } from "../base/localuser";
import { PERMISSION } from "../base/participants";
import { 
    REFRESH_IMAGE, 
    REMOVE_DOCUMENT, 
    SET_DOCUMENT_FILE, 
    SET_FOCUS_SHARE_DOCUMENT, 
    SET_CANVAS_LINE, 
    SET_DELETE_LINE,
    SET_CANVAS_ONE_LINE,
    SET_DOCUMENT_BUFFER,
    SET_DELETE_ONE_LINE,
    SET_DELETE_KEY_LINE
} from "./actionTypes";
import { getCanvasList, getFilterDocumentListByUuid, getFocusItem } from "./functions";

export function setDocumentSharedFile(file, tempUuid, isRemote = false) {
    return (dispatch, getState) => {
        if (isCheckPermission(getState(), PERMISSION.SHARE) && isRemote === false) {
            const state = getState();
            const canvasList = getCanvasList(state, file.uuid);
            
            const data = {
                ...file,
                canvasList
            };

            APP.mateManagement.sendShareDocument(data);
        }

        dispatch(setDocumentFile(file, tempUuid));
    }
}

export function setDocumentFile(data, tempUuid) {
    return {
        type: SET_DOCUMENT_FILE,
        data, tempUuid
    }
}

export function setDocumentArrayBuffer(uuid, buffer) {
    return {
        type: SET_DOCUMENT_BUFFER,
        uuid, buffer
    }
}

export function setCanvasOneLine(newLine, uuid, index) {
    return {
        type: SET_CANVAS_ONE_LINE,
        newLine, uuid, index
    }
}

export function setCanvasLine(line, uuid) {
    return {
        type: SET_CANVAS_LINE,
        line, uuid
    }
}

export function setFocusShareDocument(uuid, index, isWhiteBoard, remoteClick = true) {
    return (dispatch, getState) => {
        const focusItem = getFocusItem(getState(), isWhiteBoard);
        if (focusItem.uuid === uuid && focusItem.index === index) {
            dispatch(refreshImage());
            return;
        }
        if (!remoteClick) {
            if (!isCheckPermission(getState(), PERMISSION.SHARE)) return;
            APP.mateManagement.requestFocusItem({ uuid, index });
        }

        dispatch(setFocusDocument(uuid, index, isWhiteBoard));
    }
}

function setFocusDocument(uuid, index, isWhiteBoard) {
    return {
        type: SET_FOCUS_SHARE_DOCUMENT,
        uuid, index, isWhiteBoard
    }
}   
    

export function setDeleteOneLine(deleteLine, uuid, index) {
    return {
        type: SET_DELETE_ONE_LINE,
        deleteLine, uuid, index
    }
}

export function setDeleteKeyLine(drawKey, uuid, index) {
    return {
        type: SET_DELETE_KEY_LINE,
        drawKey, uuid, index
    }
}

export function setDeleteLine(uuid, index) {
    return {
        type: SET_DELETE_LINE,
        uuid, index
    }
}

export function refreshImage() {
    return {
        type: REFRESH_IMAGE
    }
}

export function removeDocumentFile(uuid, isWhiteBoard) {
    return {
        type: REMOVE_DOCUMENT,
        uuid,
        isWhiteBoard
    }
}